import HoverIcon from './HoverIcon';

export default HoverIcon;
